import React from 'react';
import classnames from 'classnames';
import { IconType } from '../../icons';
import { ButtonType, LinkType } from '../types';
import styles from './combo-button.module.scss';
import { Icon } from '../icon';

export type InteractionElementType = (LinkType | ButtonType) & {
  icon?: IconType;
};

export type InteractionElementProps = {
  props: InteractionElementType;
};

const isLinkType = (props: unknown): props is LinkType => typeof (props as LinkType)?.href === 'string';

export const InteractionElement: React.FC<InteractionElementProps> = ({ props }) => {
  if (isLinkType(props)) {
    const { href, label, rel, target, onClick, icon, isExternal } = props;

    return (
      <a className={classnames(styles.link, styles.cta)} href={href} rel={rel} target={target} onClick={onClick}>
        <span className={styles.inner}>
          {icon && <Icon name={icon} className={styles.leadingIcon} aria-hidden />}
          <span className={styles.label}>{label}</span>
        </span>
        {isExternal && <Icon name="external-link--small" className={styles.trailingIcon} aria-hidden />}
      </a>
    );
  }

  const { label, onClick, icon } = props;

  return (
    <button className={classnames(styles.button, styles.cta)} onClick={onClick}>
      <span className={styles.inner}>
        {icon && <Icon name={icon} className={styles.leadingIcon} aria-hidden />}
        <span className={styles.label}>{label}</span>
      </span>
    </button>
  );
};
